module.exports = __webpack_public_path__ + "bq.60ba4677c5884fa068f8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bq.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bq.svg
// module chunks = styles